import { defineStore } from 'pinia'

import { DocumentRequest } from '@/domain/pio/DocumentRequest'
import { getDocumentRequests } from '@/services/pio/documentManagementService'

interface DocumentRequestsStore {
  documentRequests: DocumentRequest[]
}

export const useDocumentRequests = defineStore('documentRequests', {
  state: () =>
    ({
      documentRequests: [],
    }) as DocumentRequestsStore,
  actions: {
    async getDocumentRequestsForVetPractice(vetPracticeId: string) {
      this.documentRequests = await getDocumentRequests(vetPracticeId).then(
        (response) => response.items
      )
    },
  },
  getters: {
    vetDocumentRequests: (state) => state.documentRequests,
  },
  persist: true,
})
